import { ALLOWED_SPACING_TOKENS, sanitizeAllowedString, sanitizeBindable, sanitizePositiveInteger, sanitizeRequiredChildren, sanitizeString } from './helpers';
export function sanitizeLoop(el, sanitizeElement) {
  const data = sanitizeBindable(el.data, value => Array.isArray(value) ? value : undefined);
  if (!data) return null;
  const children = sanitizeRequiredChildren(el.children, sanitizeElement);
  if (!children) return null;
  return {
    type: 'Loop',
    data,
    itemKey: sanitizeString(el.itemKey),
    itemAlias: sanitizeString(el.itemAlias),
    gap: sanitizeAllowedString(el.gap, ALLOWED_SPACING_TOKENS),
    maxItems: sanitizePositiveInteger(el.maxItems),
    children
  };
}